import React, {Component} from 'react'
import EnsureLoggedIn from "../../../../shared-components/EnsureLoggedIn"
import Dashboard from "./Dashboard"

class DashboardContainer extends Component{
    render(){
        return (
            <EnsureLoggedIn><Dashboard/></EnsureLoggedIn>
        )

    }
}

export default DashboardContainer;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/Dashboard/DashboardContainer.js